<template>
    <div class="row" id="tick-list">
        <div class="col-sm-12">
            <div class="card card-primary " v-if="showTickList">
                <div class="card-header">
                    {{trans('projects.cards.header.tick_list')}}
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col">
                            <ul class="nav nav-tabs pull-left">
                                <li class="nav-item active">
                                    <a class="nav-link" href="#tickListOpen" data-toggle="tab">
                                        Open ({{ tickListOpen.length }}
                                        )</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" href="#tickListInProgress" data-toggle="tab">In Progress
                                        ({{ tickListInProgress.length }})</a></li>
                                <li class="nav-item">
                                    <a class="nav-link" href="#tickListDone" data-toggle="tab">Done ({{
                                        tickListDone.length }})</a></li>
                            </ul>
                        </div>
                        <div class="col text-right form-group">
                            <a :href="tickItemsFromDefaultHref"
                               class="btn btn-secondary pull-right btn-call-modal"
                               style="margin-top: 10px; margin-bottom: 0; margin-right: 10px;"
                            >Create from template</a>
                        </div>
                    </div>
                    <div class="tab-content">
                        <div class="tab-pane fade in active show" id="tickListOpen">
                            <ul class="list-group">
                                <li class="list-group-item" v-for="task in tickListOpen">
                                    <div class="row">
                                        <div class="col-3 offset-8">
                                            <select v-model="task.status"
                                                    @change="changeTaskStatus(task)"
                                                    class="form-control task-status-select">

                                                <option v-for="(status, id) in statuses"
                                                        v-bind:value="id">{{status}}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-1">
                                            <button class="btn btn-sm pull-right btn-outline-danger"
                                                    @click="deleteTask(task)">X
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-3">
                                            <span class="who">{{task.who}} |</span>
                                            <span class="deadline">{{renderDate(task.deadline)}}</span>
                                        </div>
                                        <div class="col-sm-12">

                                            <div class="phase"><strong>{{trans('tick_list_default_items.fields.phase')}}
                                                : {{task.phase}}</strong></div>
                                            <div class="task"><strong>{{task.task}}</strong></div>
                                            <div class="note" v-if="task.note">
                                                <small>{{task.note}}</small>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="tab-pane fade" id="tickListInProgress">
                            <ul class="list-group">
                                <li class="list-group-item" v-for="task in tickListOpen">
                                    <div class="row">
                                        <div class="col-3 offset-8">
                                            <select v-model="task.status"
                                                    @change="changeTaskStatus(task)"
                                                    class="form-control task-status-select">

                                                <option v-for="(status, id) in statuses"
                                                        v-bind:value="id">{{status}}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-1">
                                            <button class="btn btn-sm pull-right btn-outline-danger"
                                                    @click="deleteTask(task)">X
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-3">
                                            <span class="who">{{task.who}} |</span>
                                            <span class="deadline">{{renderDate(task.deadline)}}</span>
                                        </div>
                                        <div class="col-sm-12">

                                            <div class="phase"><strong>{{trans('tick_list_default_items.fields.phase')}}
                                                : {{task.phase}}</strong></div>
                                            <div class="task"><strong>{{task.task}}</strong></div>
                                            <div class="note" v-if="task.note">
                                                <small>{{task.note}}</small>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="tab-pane fade" id="tickListDone">
                            <ul class="list-group">
                                <li class="list-group-item" v-for="task in tickListOpen">
                                    <div class="row">
                                        <div class="col-3 offset-8">
                                            <select v-model="task.status"
                                                    @change="changeTaskStatus(task)"
                                                    class="form-control task-status-select">

                                                <option v-for="(status, id) in statuses"
                                                        v-bind:value="id">{{status}}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-1">
                                            <button class="btn btn-sm pull-right btn-outline-danger"
                                                    @click="deleteTask(task)">X
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-3">
                                            <span class="who">{{task.who}} |</span>
                                            <span class="deadline">{{renderDate(task.deadline)}}</span>
                                        </div>
                                        <div class="col-sm-12">

                                            <div class="phase"><strong>{{trans('tick_list_default_items.fields.phase')}}
                                                : {{task.phase}}</strong></div>
                                            <div class="task"><strong>{{task.task}}</strong></div>
                                            <div class="note" v-if="task.note">
                                                <small>{{task.note}}</small>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <br>
                    <hr>
                    <br>
                    <div class="form-row form-group">
                        <div class="col-sm-12">

                            <div v-if="errorMessages.length > 0" class="alert alert-danger alert-dismissable">
                                <button type="button" class="close" data-dismiss="alert"
                                        aria-hidden="true">&times;
                                </button>
                                <strong>Error:</strong> <span v-for="errorMessage in errorMessages">{{ errorMessage }}
                                &nbsp;</span>
                            </div>
                            <div v-if="edit" class="form form-horizontal">
                                <div class="form-row">
                                    <div class="form-group col-sm-3">
                                        <label for="who">{{trans('tick_list_default_items.fields.who')}}</label>
                                        <input v-model="editTickItem.who" type="text" class="form-control"
                                               name="who" id="who"
                                        >
                                    </div>
                                    <div class="form-group col-sm-3">
                                        <label for="deadline">{{trans('tick_list_default_items.fields.deadline')}}</label>
                                        <input v-model="editTickItem.deadline" type="text" class="form-control"
                                               name="deadline" id="deadline"
                                        >
                                    </div>
                                    <div class="form-group col-sm-3">
                                        <label for="status">{{trans('tick_list_default_items.fields.status')}}</label>
                                        <select v-model="editTickItem.status" name="status"
                                                id="status"
                                                class="form-control">

                                            <option v-for="(status, id) in statuses"
                                                    v-bind:value="id">{{status}}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="form-group col">
                                        <label for="phase">{{trans('tick_list_default_items.fields.phase')}}</label>
                                        <input v-model="editTickItem.phase" type="text" class="form-control"
                                               name="phase" id="phase"
                                        >
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col">
                                        <label for="task">{{trans('tick_list_default_items.fields.task')}}</label>
                                        <input v-model="editTickItem.task" type="text" class="form-control"
                                               name="task" id="task"
                                        >
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col">
                                        <label for="note">{{trans('tick_list_default_items.fields.note')}}</label>
                                        <textarea v-model="editTickItem.note" class="form-control"
                                                  name="note" id="note"
                                        ></textarea>
                                    </div>
                                </div>
                                <div class="form-row text-right">

                                    <button class="btn btn-primary" @click="editTickListItem">Edit</button>
                                    <button class="btn btn-info" @click="edit = false">Cancel</button>
                                </div>
                            </div>
                            <div v-else class="form form-horizontal">
                                <div class="form-row">
                                    <div class="form-group col-sm-3">
                                        <label for="who">{{trans('tick_list_default_items.fields.who')}}</label>
                                        <input v-model="newTickItem.who" type="text" class="form-control"
                                               name="who" id="who"
                                        >
                                    </div>
                                    <div class="form-group col-sm-3">
                                        <label for="deadline">{{trans('tick_list_default_items.fields.deadline')}}</label>
                                        <input v-model="newTickItem.deadline" type="text" class="form-control"
                                               name="deadline" id="deadline"
                                        >
                                    </div>
                                    <div class="form-group col-sm-3">
                                        <label for="status">{{trans('tick_list_default_items.fields.status')}}</label>
                                        <select v-model="newTickItem.status" name="status"
                                                id="status"
                                                class="form-control">

                                            <option v-for="(status, id) in statuses"
                                                    v-bind:value="id">{{status}}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="form-group col">
                                        <label for="phase">{{trans('tick_list_default_items.fields.phase')}}</label>
                                        <input v-model="newTickItem.phase" type="text" class="form-control"
                                               name="phase" id="phase"
                                        >
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col">
                                        <label for="task">{{trans('tick_list_default_items.fields.task')}}</label>
                                        <input v-model="newTickItem.task" type="text" class="form-control"
                                               name="task" id="task"
                                        >
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col">
                                        <label for="note">{{trans('tick_list_default_items.fields.note')}}</label>
                                        <textarea v-model="newTickItem.note" class="form-control"
                                                  name="note" id="note"
                                        ></textarea>
                                    </div>
                                </div>
                                <div class="form-row text-right">
                                    <button class="btn btn-primary" @click="createTickListItem">Create</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="card card-no-bg">
                <button v-if="tickList.length" class="btn btn-primary" @click="makeShowTickList">Show Tick List
                </button>
                <button v-else class="btn btn-primary" @click="makeShowTickList">Create Tick List</button>
            </div>
        </div>
    </div>

</template>

<script>

    let moment = require('moment');

    import _ from 'lodash';

    export default {
        name: "project-tick-list",
        props: {
            statuses: Array,
            project: Object,
        },
        data: function () {
            return {
                edit: false,
                tickList: [],
                newTickItem: {},
                editTickItem: {},
                showTickList: false,
                errorMessages: [],
                tickItemsFromDefaultHref: laroute.route('tick_items_from_default', {project: this.project.id}),
                tickListOpen: [],
                tickListInProgress: [],
                tickListDone: [],

            };
        },
        watch: {
            showTickList: function (show) {
                if (show) {
                    setTimeout(function () {
                        VisiApp.initDatePicker($('#tick-list #deadline'));
                    }, 1000);
                }
            },
            orderedList: function (list) {
                if (list && list.length > 0) {
                    this.tickListOpen = _.filter(list
                        , function (item) {
                            return item.status == 0;
                        })
                    ;

                    this.tickListInProgress = _.filter(list
                        , function (item) {
                            return item.status == 1;
                        })
                    ;
                    this.tickListDone = _.filter(list
                        , function (item) {
                            return item.status == 2;
                        })
                    ;

                }

            }
        },
        computed: {
            orderedList: function () {
                return _.orderBy(this.tickList, function (item1) {
                    return moment(item1.deadline);
                });
            },
            // tickListOpen: function () {
            //     return this.tickList
            //         .filter(function (item) {
            //             return item.status == 0;
            //         })
            //         .sort(function (item1, item2) {
            //             if (moment(item1.deadline) > moment(item2.deadline)) {
            //                 return 1;
            //             }
            //             return -1;
            //         });
            // },
            // tickListInProgress: function () {
            //     return this.tickList
            //         .filter(function (item) {
            //             return item.status == 1;
            //         })
            //         .sort(function (item1, item2) {
            //             if (moment(item1.deadline) > moment(item2.deadline)) {
            //                 return 1;
            //             }
            //             return -1;
            //         });
            // },
            // tickListDone: function () {
            //     return this.tickList
            //         .filter(function (item) {
            //             return item.status == 2;
            //         })
            //         .sort(function (item1, item2) {
            //             if (moment(item1.deadline) > moment(item2.deadline)) {
            //                 return 1;
            //             }
            //             return -1;
            //         });
            // },
            tickListSorted: function () {
                return this.tickList.sort(function (item1, item2) {
                    if (moment(item1.deadline) > moment(item2.deadline)) {
                        return 1;
                    }
                    return -1;
                });
            }
        },
        created: function () {
            this.newItemToBase();
            this.fetchTickList();
        },
        methods: {
            trans: function (path) {
                return Lang.trans(path);
            },
            changeTaskStatus: function (task) {
                // var resource = this.$resource('/visi/api/tick-list-items{/id}');
                let vm = this;
                this.disableErrors();

                // axios.post(laroute.route('json.tick_list_items', {}))

                axios.post(laroute.route('json.tick_list_items.update', {
                    tick_list_item: task.id
                }), task)
                    .then(response => {
                        if (response.data.success) {
                            vm.fetchTickList();
                        } else {
                            vm.throwError('Error :(');
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        vm.throwError(_.values(error.response.data.errors));
                    });

                // resource.update({id: task.id}, task).then(function (response) {
                //     response = response.body;
                //     if (response.success) {
                //         vm.fetchTickList();
                //     } else {
                //         this.throwError(response.error);
                //     }
                // });
            },
            startEdit: function (periodItem) {
                this.edit = true;
                this.editTickItem = Object.assign({}, periodItem);
            },
            deleteTask: function (task) {
                // var resource = this.$resource('/visi/api/tick-list-items{/id}');
                let vm = this;
                this.disableErrors();
                var r = confirm("Are you sure to delete this item ?");
                if (r == true) {

                    axios.delete(laroute.route('json.tick_list_items', {
                        tick_list_item: task.id
                    }))
                        .then(response => {
                            if (response.data.success) {
                                vm.fetchTickList();
                            } else {
                                vm.throwError('Error :(');
                            }
                        })
                        .catch(error => {
                            console.log(error);
                            vm.throwError(_.values(error.response.data.errors));

                        })

                    // resource.delete({id: task.id}).then(function (response) {
                    //     response = response.body;
                    //     if (response.success) {
                    //         this.fetchTickList();
                    //     } else {
                    //         this.throwError(response.error);
                    //     }
                    // });
                }

            },
            renderDate: function (date) {
                return date;
            },
            newItemToBase: function () {
                this.newTickItem = Object.assign({}, this.newTickItem,
                    {
                        project_id: this.project.id,
                        phase: "",
                        who: "",
                        task: "",
                        deadline: moment().format('DD.MM.YYYY'),
                        status: "",
                        note: ""
                    });

            },
            throwError: function (error) {
                if (Array.isArray(error)) {
                    this.errorMessages = error;
                } else {
                    this.errorMessages = [error];
                }
            },
            disableErrors: function () {
                this.errorMessages = [];
            },
            createTickListItem: function () {
                // var resource = this.$resource('/visi/api/tick-list-items{/id}');
                let vm = this;
                this.disableErrors();

                axios.post(laroute.route('project.tick_list_items.create', {
                    project: this.project.id
                }), this.newTickItem)
                    .then(response => {
                        if (response.data.success) {
                            vm.fetchTickList();
                            vm.newItemToBase();
                        } else {
                            vm.throwError('Error :(');
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        vm.throwError(_.values(error.response.data.errors));
                    });

                // resource.save(this.newTickItem).then(function (response) {
                //     response = response.body;
                //     if (response.success) {
                //         vm.fetchTickList();
                //         vm.newItemToBase();
                //     } else {
                //         this.throwError(response.error);
                //     }
                // });
            },
            editTickListItem: function () {
                // var resource = this.$resource('/visi/api/tick-list-items{/id}');
                let vm = this;
                this.disableErrors();


                axios.post(laroute.route('json.tick_list_items.update',
                    {tick_list_item: this.editTickitem.id}),
                    this.editTickItem)
                    .then(response => {
                        if (response.data.success) {
                            vm.edit = false;
                            vm.fetchTickList();
                        } else {
                            vm.throwError('Error :(');
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        vm.throwError(_.values(error.response.data.errors));
                    });

                // resource.update({id: this.editTickItem.id}, this.editTickItem).then(function (response) {
                //     response = response.body;
                //     if (response.success) {
                //         vm.edit = false;
                //         vm.fetchTickList();
                //     } else {
                //         this.throwError(response.error);
                //     }
                // });
            },
            makeShowTickList: function () {
                this.showTickList = true;
            },
            removeDeadlineTime: function () {
                var vm = this;
                vm.tickList.filter(function (tickItem) {
                    tickItem.deadline = moment(tickItem.deadline).format('DD.MM.YYYY');
                })
            },
            fetchTickList: function () {
                let vm = this;
                // var resource = this.$resource('/visi/api/tick-list-items{/id}');

                axios.get(laroute.route('project.tick_list_items', {project: this.project.id}))
                    .then(response => {
                        if (response.data.success) {
                            vm.tickList = response.data.data;
                            vm.removeDeadlineTime();
                        } else {
                            vm.throwError('Error :(');
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        vm.throwError(_.values(error.response.data.errors));
                    });

                // resource.get({project_id: "{{$project->id}}"}).then(function (response) {
                //     response = response.body;
                //
                //     if (response.success) {
                //         vm.tickList = response.data;
                //         this.removeDeadlineTime();
                //     } else {
                //         this.throwError(response.error);
                //     }
                //
                // });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/projects/ProjectTickList.vue